/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".menu-open[_ngcontent-%COMP%]   .treeview-menu[_ngcontent-%COMP%]{display:block}.treeview[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background-color:transparent;border:0;color:#b8c7ce;margin-left:13px;padding-bottom:7px;min-width:100%;text-align:left;margin-top:10px;outline:0}.treeview[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{width:30px;font-size:16px!important}"];
export { styles as styles };
